import { render, staticRenderFns } from "./SalesCrmCompany.vue?vue&type=template&id=05d73ca2&scoped=true&"
import script from "./SalesCrmCompany.vue?vue&type=script&lang=js&"
export * from "./SalesCrmCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d73ca2",
  null
  
)

export default component.exports